import { createContext, useContext, useState } from "react";

const GlobalContext = createContext();
export const useGlobalContext = () => useContext(GlobalContext);

const getInitialConfig = () => ({
  baseUrl: process.env.REACT_APP_BASE_URL,
  urlDocumentos: process.env.REACT_APP_DOCUMENTOS_URL,
  urlMedidores: process.env.REACT_APP_MEDIDORES_URL,
  urlCobranzas: process.env.REACT_APP_COBRANZAS_URL,
  urlContratos: process.env.REACT_APP_CONTRATOS_URL,
});

const AppContext = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const initialConfig = getInitialConfig();

  const headerText = new Headers();
  headerText.append("Content-Type", "application/json;charset=UTF-8");

  const [baseUrl, setBaseUrl] = useState(initialConfig.baseUrl);
  const [urlDocumentos, setUrlDocumentos] = useState(initialConfig.urlDocumentos);
  const [urlMedidores, setUrlMedidores] = useState(initialConfig.urlMedidores);
  const [urlCobranzas, setUrlCobranzas] = useState(initialConfig.urlCobranzas);
  const [urlContratos, setUrlContratos] = useState(initialConfig.urlContratos);

  return (
    <GlobalContext.Provider
      value={{
        baseUrl,
        setBaseUrl,
        isLoggedIn,
        setIsLoggedIn,
        urlDocumentos,
        setUrlDocumentos,
        urlMedidores,
        setUrlMedidores,
        urlCobranzas,
        setUrlCobranzas,
        headerText,
        urlContratos,
        setUrlContratos,
      }}  
    >
      {children}
    </GlobalContext.Provider>
  );
};

export default AppContext;
